import CRMPermission from '@/models/enums/permissions/CRMPermission'
import RouteName from '@/models/enums/RouteName'

export default [
  {
    path: '/settings/orders',
    name: RouteName.SettingsOrders,
    component: () => import('@/pages/Settings/Orders.vue'),
    meta: {
      permissions: [CRMPermission.SettingsOrders],
      breadcrumb: {
        label: 'Заказы',
        parent: RouteName.Settings,
      },
    },
  },
]
